import store from './../game/store/index.js';
import config from './../config/config.js'
import * as moment from 'moment';



const report = {
	install(Vue, options) {


		Vue.prototype.$report = {
			safety: function (range, state) {
				// Safety Certainty Calc = 100 – {3.5*ln[(Unresolved Critical Zone Violations + 1)^2]} – {5*ln[(Unresolved Fall Alerts + 1)^2]}
				let data = [];
				if (!state) state = store.state;

				if (state.day == 1 && state.time == 0) return data;

				if (!range) range = [1, store.state.day]
				else range[0] = Math.max(1, range[0]);

				for (let i = range[0]; i <= range[1]; i++) {
					let zone_violations = Object.keys(Vue.prototype.$finder.all({
						type: 'entry',
						day: i
					}, store.state.alert)).length;
					let unresolved_falls = Object.keys(Vue.prototype.$finder.all({
						type: 'fall',
						day: i,
						status: 'pending'
					}, store.state.alert)).length;
					unresolved_falls += Object.keys(Vue.prototype.$finder.all({
						type: 'man-down',
						day: i,
						status: 'pending'
					}, store.state.alert)).length;
					let index = 100 - (3.5 * Math.log(Math.pow(zone_violations + 1, 2))) - (5 * Math.log(Math.pow((unresolved_falls + 1), 2)));
					data.push(index)
				}
				return data;
			},

			mustering: function(range, state) {
				let data = [];

				if (!state) state = store.state;

				if (state.day == 1 && state.time == 0) return data;

				if (!range) range = [1, state.day]
				else range[0] = Math.max(1, range[0]);

				for (let i = range[0]; i <= range[1]; i++) {
					let musterings = Vue.prototype.$finder.all({type: 'muster', day: i, status: 'end'}, state.log);
					if (musterings.length == 0 ) continue;
					let total = 0;
					for (let j in musterings) {
						total += parseFloat(musterings[j].stopwatch);
					}

					let score = total / Object.keys(musterings).length;
					score = 100 - (score - 300) / 18;
					data.push(score);
				}

				return data;
			},

			mustering_efficiency: function (range) {
				let data = [];
				if (store.state.day == 1 && store.state.time == 0) return data;
				if (!range) range = [1, store.state.day];
				else range[0] = Math.max(1, range[0]);

				const log = store.state.log;

				for (let i = range[0]; i <= range[1]; i++) {
					const events = Vue.prototype.$finder.all({type: 'muster', day: i, status: 'end'}, log);
					const length = Object.keys(events).length;

					let index = 100;

					if (length > 0) {
						const average = (Object.keys(events).map(key => {
							const {time, end} = events[key];
							return end - time;
						}).reduce((total, score) => total + score)) / (length * 60);

						index = 105 - Vue.prototype.$number.format(average);
						if (index < 0) index = 0;
						if (index > 100) index = 100;
					}
					data.push(index);
				}

				return data;

			},
			work_time: function(range, state) {
				return this.zone_time(range, 'work', state)
			},
			zone_time: function(range, zone, state) {
				let data = [];
				var total = {};
				var total_time  = {};

				if (!state) state = store.state;

				if (state.day == 1 && state.time == 0) return data;

				if (!range) range = [1, state.day]
				else range[0] = Math.max(1, range[0]);


				for (let worker_id in state.workers) {

					let worker = state.workers[worker_id];

					let routine = config.routines[worker.type];
					let start_time = config.start_time;
					let end_time = config.end_time;
					for (let time in routine) {
						if (routine[time] == 'start') {
							time = time.split(':');
							start_time = { hour: time[0], minute: time[1]}
						}
						if (routine[time] == 'end') {
							time = time.split(':');
							end_time = { hour: time[0], minute: time[1]}
						}
					}


					let time_range = moment().hour(end_time.hour).minute(end_time.minute).second('0').diff(moment().hour(start_time.hour).minute(start_time.minute).second('0'))/1000;
					for (let i = range[0]; i <= range[1]; i++) {

						let log = state.watcher[i][worker_id];
						if (log == undefined) continue;

						if (i == range[1]) {
							time_range = Math.min(time_range, state.time);
						}

						if (total_time[i] == undefined) total_time[i] = 0;
						total_time[i] += time_range;


						let entry = Vue.prototype.$finder.all({type: 'entry'}, log, true);
						let count = {};
						for (let j in entry) {
							let zone_id = entry[j].zone_id
							let entry_zone = Vue.prototype.$zone.get(zone_id);
							if (entry_zone.type != zone) continue;
							if (count[zone_id] == undefined) count[zone_id] = 0;
							let exit = Vue.prototype.$finder.all({type: 'exit', 'zone_id': zone_id}, log);
							if (total[i] == undefined) total[i] = 0;
							if (exit[count[zone_id]] !== undefined) {
								total[i] += (exit[count[zone_id]].time - entry[j].time);
							}
							else if (i == range[1]) {
								total[i] += (state.time - entry[j].time);
							}
							count[zone_id]++
						}
					}

				}


				for (let i in total) {
					data.push((total[i] * 100) / total_time[i]);
				}

				return data;
			},
			first_starts: function(range, state) {

				let $finder = Vue.prototype.$finder;
				if (!state) state = store.state

				let data = [];
				let total = {};

				if (state.day == 1 && state.time == 0) return data;

				if (!range) range = [1, state.day]
				else range[0] = Math.max(1, range[0]);

				let first_starts = config.first_starts;
				let start_time = config.start_time;

				for (let d in state.watcher) {

					let watcher = state.watcher[d];
					for (let worker_id in watcher) {
						let worker = state.workers[worker_id];

						let routine = config.routines[worker.type];
						let work_time;
						for (let time in routine) {
							if (routine[time] == 'work') {
								time = time.split(':');
								work_time = { hour: time[0], minute: time[1]}
								break;

							}
						}

						if (!work_time) continue;

						let log = watcher[worker_id];

						let first_starts_threshold = moment().hour(work_time.hour).minute(work_time.minute).second('0').diff(moment().hour(start_time.hour).minute(start_time.minute).second('0'))/1000
						first_starts_threshold += first_starts * 60;

						for (let i = range[0]; i <= range[1]; i++) {

							let entry = $finder.all({type: 'entry', day: i}, log, true);
							if (total[i] == undefined) total[i] = 0;

							for (let j in entry) {
								let entry_zone = Vue.prototype.$zone.get(entry[j].zone_id);
								if (entry_zone.type == 'work' && entry[j].time <= first_starts_threshold) {
									total[i]++;
									break;
								}
							}

						}
					}

				}

				for (let i in total) {
					data.push((total[i] * 100) / Object.keys(state.workers).length);
				}


				return data;
			},
			travel_time(day, state) {

				let total_time = 0;
				let total = 0;

				if (!state) state = store.state;

				if (state.day == 1 && state.time == 0) return 0;

				for (let worker_id in state.workers) {

					let worker = state.workers[worker_id];

					let routine = config.routines[worker.type];
					let start_time = config.start_time;
					let end_time = config.end_time;
					for (let time in routine) {
						if (routine[time] == 'start') {
							time = time.split(':');
							start_time = { hour: time[0], minute: time[1]}
						}
						if (routine[time] == 'end') {
							time = time.split(':');
							end_time = { hour: time[0], minute: time[1]}
						}
					}

					let time_range = moment().hour(end_time.hour).minute(end_time.minute).second('0').diff(moment().hour(start_time.hour).minute(start_time.minute).second('0'))/1000;
					if (day == state.day) time_range = Math.min(time_range, state.time);

					total += time_range;


					let log = state.watcher[day][worker_id];

					if (log == undefined) continue;
					let status = 0;
					let time = 0;
					for (let j in log) {
						if (log[j].type == 'exit' && !status) {
							status = 1;
							time = log[j].time;
						}
						else if (log[j].type == 'entry' && status) {
							total_time += log[j].time - time;
							status = 0;
						}
					}
				}

				if (!total) return 0;


				return (total_time * 100) / total;
			},
			color(index) {
				const colors = config.report_colors;
				let color = colors[0];
				for (let i in colors) {
					if (index >= i) color = colors[i];
				}

				return color;
			},

		}

	}
};

export default report;
